function validateEmail(email) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

function validatePhoneNumber(phoneNumber) {
  return phoneNumber.length === 10 || phoneNumber.length === 11;
}

const PASSWORD_MIN_LENGTH = 6; // mesmo mínimo da API (common/features/fidelidade/senha.js)

function validatePassword(password) {
  return typeof password === "string" && password.length >= PASSWORD_MIN_LENGTH;
}

export {
  validateEmail,
  validatePhoneNumber,
  validatePassword,
  PASSWORD_MIN_LENGTH,
};
